import crypto from 'crypto'

const ALGORITHM = 'aes-256-gcm'
const SECRET_KEY = crypto
  .createHash('sha256')
  .update(process.env.NEXTAUTH_SECRET || '')
  .digest()

export const encrypt = (text: string): string => {
  const iv = crypto.randomBytes(16)

  const cipher = crypto.createCipheriv(ALGORITHM, SECRET_KEY, iv)
  const encrypted = Buffer.concat([cipher.update(text, 'utf8'), cipher.final()])
  const authTag = cipher.getAuthTag()

  return Buffer.concat([iv, authTag, encrypted]).toString('base64')
}

export const decrypt = (encryptedText: string): string => {
  const data = Buffer.from(encryptedText, 'base64')

  const iv = data.subarray(0, 16)
  const authTag = data.subarray(16, 32)
  const encrypted = data.subarray(32)

  const decipher = crypto.createDecipheriv(ALGORITHM, SECRET_KEY, iv)

  decipher.setAuthTag(authTag)

  return Buffer.concat([decipher.update(encrypted), decipher.final()]).toString(
    'utf8',
  )
}

export const credentialHash = (text: string): string => {
  return crypto
    .createHmac('sha256', process.env.NEXTAUTH_SECRET!)
    .update(text)
    .digest('hex')
}
